import injectScript from '@gumtree/shared/src/util/inject-script';

export default injectScript;
